<template>
    <div id="app">
        <header class="app-header" v-if="$route.name!=='mailOrders'">
            <van-icon
                    @click="goBack"
                    class="back-icon"
                    size="0.5rem"
                    color="#fff"
                    name="arrow-left"
                    v-show="backShow"
            ></van-icon>
            <h1>{{ $store.state.mapTitle ? $store.state.mapTitle : $store.state.title }}</h1>
            <img class="nav-icon" src="./assets/nav1.png" @click="toggleNav" v-show="toggleShow && $route.query.mark != 'dgdlyyb'"/>
            <section v-show="navShow" class="nav-bg" @click="navShow = false">
                <ul class="nav-content">
                    <router-link tag="li" to="/preOrder">
                        <img src="./assets/nav_preorder.png" alt=""/>
                        <p>预约下单</p>
                    </router-link>
                    <router-link tag="li" to="/search/branch">
                        <img src="./assets/nav_dot.png" alt=""/>
                        <p>网点查询</p>
                    </router-link>
                    <router-link tag="li" to="/search/logistics">
                        <img src="./assets/nav_wuliu.png" alt=""/>
                        <p>物流查询</p>
                    </router-link>
                    <router-link tag="li" to="/order/myorder">
                        <img src="./assets/nav_myorder.png" alt=""/>
                        <p>我的订单</p>
                    </router-link>
                    <router-link tag="li" to="/order/waybill">
                        <img src="./assets/icon_airport.png" alt=""/>
                        <p>我的运单</p>
                    </router-link>
                    <router-link tag="li" to="/user">
                        <img src="./assets/nav_user.png" alt=""/>
                        <p>个人中心</p>
                    </router-link>
                </ul>
            </section>
        </header>
        <keep-alive>
            <router-view class="app-body" v-if="$route.meta.keepAlive"/>
        </keep-alive>
        <router-view class="app-body" v-if="!$route.meta.keepAlive"/>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "App",
        data() {
            return {
                navShow: false,
                notice: false
            };
        },
        created() {

            if (
                this.$axios.defaults.baseURL !== "https://dgyz.cg1717.com/v1/" &&
                window.location.href.indexOf("dgyz.cg1717.com") > 0
            ) {
                this.notice = true;
            } else {
                this.notice = false;
            }
            if (this.$store.state.token) {
                let params = {
                    params: "TRANSPORT_WAY"
                };
                this.$axios.post("dict/info", params).then(res => {
                    if (res.data.code === 200) {
                        let d = res.data.data;
                        d.forEach(val => {
                            val.name = val.dictName;
                        });
                        this.$store.commit({
                            type: "getDict",
                            t: "transport",
                            list: d
                        });
                    }
                });
                params = {
                    params: "PACK_NAME_TYPE"
                };
                this.$axios.post("dict/info", params).then(res => {
                    if (res.data.code === 200) {
                        let d = res.data.data;
                        d.forEach(val => {
                            val.name = val.dictName;
                        });
                        this.$store.commit({
                            type: "getDict",
                            t: "pack",
                            list: d
                        });
                    }
                });
                params = {
                    params: "PAY_MEANS_TYPE"
                };
                this.$axios.post("dict/info", params).then(res => {
                    if (res.data.code === 200) {
                        let d = res.data.data;
                        d.forEach(val => {
                            val.name = val.dictName;
                        });
                        this.$store.commit({
                            type: "getDict",
                            t: "pay",
                            list: d
                        });
                    }
                });
                params = {
                    params: "DELIVERY_TYPE"
                };
                this.$axios.post("dict/info", params).then(res => {
                    if (res.data.code === 200) {
                        let d = res.data.data;
                        d.forEach(val => {
                            val.name = val.dictName;
                        });
                        this.$store.commit({
                            type: "getDict",
                            t: "delivery",
                            list: d
                        });
                    }
                });
                params = {
                    params: "TRACKING_STATUS"
                };
                this.$axios.post("dict/info", params).then(res => {
                    if (res.data.code === 200) {
                        let d = res.data.data;
                        d.forEach(val => {
                            val.name = val.dictName;
                        });
                        this.$store.commit({
                            type: "getDict",
                            t: "status",
                            list: d
                        });
                    }
                });
                params = {
                    params: "PRODUCT_NAME_TYPE"
                };
                this.$axios.post("dict/info", params).then(res => {
                    if (res.data.code === 200) {
                        let d = res.data.data;
                        d.forEach(val => {
                            val.name = val.dictName;
                        });
                        this.$store.commit({
                            type: "getDict",
                            t: "product",
                            list: d
                        });
                    }
                });

            }
        },
        methods: {
            toggleNav() {
                this.navShow = !this.navShow;
            },
            goBack() {
                this.$router.go(-1);
            }
        },
        computed: mapState({
            title: state => state.title,
            toggleShow: state => state.toggleShow,
            backShow: state => state.backShow
        }),
        watch: {
            $route({name}) {
                this.navShow = false;
                if (name == 'mailOrders') {
                    document.title = '寄件下单'
                } else {
                    document.title = '云企'
                }
            }
        }
    };
</script>

<style lang="scss">
    #app {
        font-family: "Avenir", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        display: flex;
        flex-direction: column;

        .app-body {
            flex: 1;
            overflow: scroll;
        }
    }

    html, body, #app {
        height: 100%;
        overflow: hidden;
    }

    body {
        background-color: #f5f5f5;
    }

    html,
    body,
    ul,
    li,
    div,
    p,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        margin: 0;
        padding: 0;
        font-weight: normal;
    }

    ul,
    li {
        list-style: none;
    }

    a,
    i {
        color: #000;
        text-decoration: none;
        font-style: normal;
    }

    input {
        border: 0;
        outline: 0;
        line-height: 100%;
    }

    .app-header {
        // background-image: url("./assets/header_bg.png");
        background-color: #02c5ff;
        background-size: 100%;
        color: #fff;
        width: 100%;
        height: 45px;
        line-height: 45px;
        padding: 0 0.25rem;
        box-sizing: border-box;
        position: relative;
        z-index: 111;

        .back-icon {
            line-height: 45px;
            position: absolute;
            top: 0;
            left: 0.375rem;
            width: 1rem;
        }

        h1 {
            line-height: 45px;
            font-size: 0.45rem;
            text-align: center;
            font-weight: normal;
        }

        .nav-icon {
            position: absolute;
            top: 50%;
            right: 0.375rem;
            width: 0.625rem;
            height: 0.625rem;
            -webkit-transform: translateY(-50%);
            -moz-transform: translateY(-50%);
            -ms-transform: translateY(-50%);
            -o-transform: translateY(-50%);
            transform: translateY(-50%);
        }
    }

    .nav-bg {
        position: fixed;
        top: 45px;
        right: 0;
        left: 0;
        bottom: 0;
    }

    .nav-content {
        position: absolute;
        top: 0;
        right: 0;
        background: #37363c;
        text-align: center;
        padding: 0.2rem;
        font-size: 0.3rem;
        z-index: 999;

        li {
            border-bottom: 1px solid #57565b;
            padding-bottom: 0.2rem;
            margin-bottom: 0.2rem;
            color: #fff;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;

            img {
                width: 0.5rem;
                margin-bottom: 0.2rem;
            }

            p {
                line-height: normal;
            }

            &:last-child {
                padding-bottom: 0;
                margin-bottom: 0;
                border: 0;
            }
        }
    }

    // 全局配置vant组件样式
    .van-button--primary {
        background-color: #0b92e6;
        border-color: #0b92e6;
        transform: translateY(2px);
    }

    .van-button--disabled {
        background-color: #e8e8e8;
        border: 1px solid #e5e5e5;
    }

    .van-icon {
        color: #000;
    }

    .van-dialog__message {
        text-align: center;
    }

    .popup-header {
        width: 100%;
        height: 1.17rem;
        box-sizing: border-box;
        position: relative;

        &-title {
            padding-left: 0.4rem;
            font-size: 0.4rem;
            height: 1.17rem;
            line-height: 1.17rem;
            font-weight: normal;
            position: relative;
            border-bottom: 1px solid #e5e5e5;
        }

        &-icon {
            position: absolute;
            right: 0.4rem;
            top: 50%;
            transform: translateY(-50%);
        }
    }
</style>
